import React from "react";
import styled from "styled-components";
import { FONTS, COLORS, BREAKPOINTS } from "../../utils/styleConstants";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1.5rem 0;
`;

// Contenedor para el enlace de descarga, alineado a la derecha
const DownloadContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 1rem;
`;

// Contenedor para los botones principales en fila
const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  
  @media (max-width: ${BREAKPOINTS.MOBILE}) {
    flex-direction: column;
  }
`;

const Button = styled.button`
  padding: 0.75rem 1.5rem;
  border-radius: 2rem;
  font-weight: 500;
  font-size: 0.95rem;
  cursor: pointer;
  transition: all 0.2s;
  font-family: ${FONTS.SECONDARY};
  
  &:focus {
    outline: none;
  }
  
  @media (max-width: ${BREAKPOINTS.MOBILE}) {
    padding: 1rem 1.5rem;
    width: 100%;
  }
`;

// Azul oscuro para Aceptar
const BlueButton = styled(Button)`
  background-color: #20376e; /* Azul oscuro */
  color: white;
  border: none;
  box-shadow: 0 2px 4px rgba(32, 55, 110, 0.2);
  
  &:hover {
    background-color: #152754; /* Un tono más oscuro al hacer hover */
  }
  
  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
    box-shadow: none;
  }
`;

// Gris azulado para Rechazar
const GrayButton = styled(Button)`
  background-color: white;
  color: #a8b9d5;
  border: 1px solid #dbe4f2;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  
  &:hover {
    background-color: #f5f8fd;
  }
  
  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
    box-shadow: none;
  }
`;

// Mantener igual para Contraofertar
const OutlineButton = styled(Button)`
  background-color: transparent;
  color: ${COLORS.PRIMARY};
  border: 1px solid ${COLORS.PRIMARY};
  
  &:hover {
    background-color: #fff8f6;
  }
  
  &:disabled {
    color: #ccc;
    border-color: #ccc;
    cursor: not-allowed;
  }
`;

// Descargar PDF - texto naranja y subrayado
const DownloadLink = styled.button`
  background-color: transparent;
  color: ${COLORS.PRIMARY}; /* Color naranja */
  border: none;
  text-decoration: underline;
  font-size: 0.95rem;
  font-family: ${FONTS.SECONDARY};
  cursor: pointer;
  padding: 0;
  
  &:hover {
    color: #e06542; /* Un tono más oscuro al hover */
  }
  
  &:disabled {
    color: #ccc;
    cursor: not-allowed;
  }
`;

const OfferActionButtons = ({
  onAccept,
  onReject,
  onCounteroffer,
  onDownloadPdf,
  disabled = false,
  showCounteroffer = true
}) => {
  return (
    <Container>
      {/* Fila superior - solo el enlace Descargar PDF */}
      <DownloadContainer>
        <DownloadLink onClick={onDownloadPdf} disabled={disabled}>
          Descargar PDF
        </DownloadLink>
      </DownloadContainer>
      
      {/* Fila inferior - botones principales */}
      <ButtonsContainer>
        <GrayButton onClick={onReject} disabled={disabled}>
          Rechazar
        </GrayButton>
        <BlueButton onClick={onAccept} disabled={disabled}>
          Aceptar
        </BlueButton>
        {showCounteroffer && (
          <OutlineButton onClick={onCounteroffer} disabled={disabled}>
            Contraofertar
          </OutlineButton>
        )}
      </ButtonsContainer>
    </Container>
  );
};

export default OfferActionButtons; 